'use strict';
angular.module('broadcastPendingRouterModule', [])
    .config(['$stateProvider', function($stateProvider) {
        $stateProvider.state('front.editctr.broadcast.pending', {
            url: '/pending?siteid',
            views: {
                "main@front.editctr": {
                    templateUrl: "./editingCenter/broadcast/pending/main_tpl.html",
                    controller: "broadcastPendingCtrl"
                }
            }
        })
    }]);